export default class AdfFooter
{


    constructor ()
    {
        this.footer = document.querySelector( '#footer' )


        this.showExternalLinks();
    }


    showExternalLinks ()
    {

        const links = this.footer.querySelectorAll( '.nav-menu a' );

        if ( links.length < 1 )
        {
            return;
        }


        Array.from( links ).forEach( ( el, i ) =>
        {

            const href   = el.getAttribute( 'href' );
            const isHash = href === '#';

            if ( isHash || (typeof href[ 0 ] !== 'undefined' && (href[ 0 ] === '#' || href[ 0 ] === '/')) )
            {
                return true;
            }


            try
            {


                const linkDomain = new URL( href ).host;


                if ( linkDomain !== window.location.hostname )
                {
                    el.classList.add( 'external-link' );
                }
            }

            catch (e)
            {

            }


        } );
    }

}
